import { Operation } from 'flow/service/changelog/types';

export const UI_EFFECT_DEBOUNCE_MS = 250;
export const DRAWER_DEBOUNCE_MS = 100;

export const undoUiEffectMap: Record<Operation, Operation> = {
  [Operation.Add]: Operation.Remove,
  [Operation.Modify]: Operation.Modify,
  [Operation.Remove]: Operation.Add,
};
